var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"social-icon"},[_c('a',{attrs:{"href":_vm.icon.url,"target":"_blank"},on:{"click":_vm.onClick}},[_c('span',{class:_vm.classlist})])])}
var staticRenderFns = []

export { render, staticRenderFns }